import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { Form } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../Config";
import Examination_navbar from "./Examination_navbar";
import SessionsDropDown from "../Shared/SessionsDropDown";
import ExamsDropDown from "../Shared/ExamsDropDown";
import { scrollToTop } from "../Shared/ScrollOnTop";

const createComponentRow = (sortOrder) => ({
  Source_Exam_ID: "",
  Weightage_Percent: 100,
  Weightage_Mode: "PercentOfExam",
  Display_Label: "",
  Include_In_Total: true,
  Sort_Order: sortOrder,
});

function EditResultCard() {
  const params = useParams();
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [cardId] = useState(parseInt(params.id, 10) || 0);
  const [Title, setTitle] = useState("");
  const [PrintTitle, setPrintTitle] = useState("");
  const [ResultCardCode, setResultCardCode] = useState("");
  const [SessionID, setSessionID] = useState(0);
  const [ResultType, setResultType] = useState("Single");
  const [GradeScaleType, setGradeScaleType] = useState("Standard");
  const [components, setComponents] = useState([createComponentRow(1)]);

  useEffect(() => {
    document.title = "Edit Result Card";
    if (!cardId) {
      setPageLoading(false);
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "ResultCard/GetResultCardByID",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType, ID: cardId },
    })
      .then((response) => {
        if (response.data.status_code === 1 && response.data.ResultCard) {
          const card = response.data.ResultCard;
          setTitle(card.Title || "");
          setPrintTitle(card.Print_Title || "");
          setResultCardCode(card.ResultCard_Code || "");
          setSessionID(card.Session_ID || 0);
          setResultType(card.Result_Type || "Single");
          setGradeScaleType(card.Grade_Scale_Type || "Standard");
          if (card.Components && card.Components.length > 0) {
            setComponents(
              card.Components.map((row, index) => ({
                Source_Exam_ID:
                  row.Source_Exam_ID != null && row.Source_Exam_ID !== ""
                    ? String(row.Source_Exam_ID)
                    : "",
                Exam_Label:
                  [row.Exam_Print_Title, row.Exam_Name]
                    .filter(Boolean)
                    .join(" ")
                    .trim() || "",
                Weightage_Percent: row.Weightage_Percent ?? 100,
                Weightage_Mode: row.Weightage_Mode || "PercentOfExam",
                Display_Label: row.Display_Label || "",
                Include_In_Total: row.Include_In_Total !== false,
                Sort_Order: row.Sort_Order || index + 1,
              }))
            );
          }
        } else {
          toast.error(response.data.status_message || "Result card not found.");
        }
        setPageLoading(false);
      })
      .catch(() => {
        setPageLoading(false);
        toast.error("Network error.");
      });
  }, [cardId]);

  const updateComponent = (index, field, value) => {
    setComponents((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [field]: value } : row))
    );
  };

  const addComponentRow = () => {
    setComponents((prev) => [...prev, createComponentRow(prev.length + 1)]);
  };

  const removeComponentRow = (index) => {
    if (components.length <= 1) {
      toast.error("At least one source exam is required.");
      return;
    }
    setComponents((prev) =>
      prev
        .filter((_, i) => i !== index)
        .map((row, i) => ({ ...row, Sort_Order: i + 1 }))
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const hasInvalidComponent = components.some(
      (row) => !row.Source_Exam_ID || row.Weightage_Percent === ""
    );
    if (hasInvalidComponent) {
      toast.error("Each component must have a source exam and weightage.");
      setValidated(true);
      return;
    }

    setLoading(true);

    const payload = {
      AccessKey,
      UserID,
      MemberType,
      ID: cardId,
      Title,
      Print_Title: PrintTitle,
      ResultCard_Code: ResultCardCode,
      Session_ID: SessionID,
      Result_Type: ResultType,
      Grade_Scale_Type: GradeScaleType,
      School_ID: 1,
      Components: components.map((row, index) => ({
        Source_Exam_ID: parseInt(row.Source_Exam_ID, 10),
        Weightage_Percent: parseFloat(row.Weightage_Percent),
        Weightage_Mode: row.Weightage_Mode,
        Display_Label: row.Display_Label,
        Include_In_Total: row.Include_In_Total,
        Sort_Order: index + 1,
      })),
    };

    axios({
      method: "post",
      url: config.base_url + "ResultCard/SaveResultCard",
      headers: { "Content-Type": "application/json" },
      data: payload,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message);
        } else {
          toast.error(response.data.status_message || "Update failed.");
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network error.");
      });

    setValidated(true);
  };

  if (pageLoading) {
    return (
      <>
        <Examination_navbar />
        <div className="page-content text-center py-5">
          <Spinner animation="border" role="status" />
        </div>
      </>
    );
  }

  return (
    <>
      <Examination_navbar />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/ExaminationSystem/ExaminationDashboard">
                      Examinations
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Edit Result Card
                  </li>
                </ol>
              </nav>
              <div className="page-title">Edit Result Card</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/ExaminationSystem/ManageResultCards"
                  className="button button-white button-icon"
                  onClick={scrollToTop}
                >
                  Manage Result Cards
                  <i className="ri-list-check"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Result Card Code</label>
                      <input
                        type="text"
                        className="form-control"
                        required
                        value={ResultCardCode}
                        onChange={(e) => setResultCardCode(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        className="form-control"
                        required
                        value={Title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="form-group mb-3">
                      <label>Print Title</label>
                      <input
                        type="text"
                        className="form-control"
                        required
                        value={PrintTitle}
                        onChange={(e) => setPrintTitle(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Session</label>
                      <select
                        className="form-select"
                        required
                        value={String(SessionID || "")}
                        onChange={(e) =>
                          setSessionID(parseInt(e.target.value, 10) || 0)
                        }
                      >
                        <option value="">Please Select</option>
                        <SessionsDropDown selectedSession={SessionID} />
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Result Type</label>
                      <select
                        className="form-select"
                        required
                        value={ResultType}
                        onChange={(e) => setResultType(e.target.value)}
                      >
                        <option value="Single">Single</option>
                        <option value="Composite">Composite</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Grade Scale Type</label>
                      <select
                        className="form-select"
                        required
                        value={GradeScaleType}
                        onChange={(e) => setGradeScaleType(e.target.value)}
                      >
                        <option value="Standard">Standard</option>
                        <option value="Combined">Combined</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0">Source Exam Components</h6>
                  <button
                    type="button"
                    className="button button-white button-sm"
                    onClick={addComponentRow}
                  >
                    <i className="ri-add-line"></i> Add Component
                  </button>
                </div>

                {components.map((row, index) => (
                  <div className="card mb-3" key={index}>
                    <div className="card-body">
                      <div className="row align-items-end">
                        <div className="col-md-3">
                          <label>Source Exam</label>
                          <select
                            className="form-select"
                            required
                            value={String(row.Source_Exam_ID || "")}
                            onChange={(e) =>
                              updateComponent(
                                index,
                                "Source_Exam_ID",
                                e.target.value
                              )
                            }
                          >
                            <option value="">Please Select</option>
                            <ExamsDropDown
                              SessionID={SessionID}
                              ensureExams={
                                row.Source_Exam_ID
                                  ? [
                                      {
                                        id: row.Source_Exam_ID,
                                        label: row.Exam_Label,
                                      },
                                    ]
                                  : []
                              }
                            />
                          </select>
                        </div>
                        <div className="col-md-2">
                          <label>Weightage %</label>
                          <input
                            type="number"
                            className="form-control"
                            min="0"
                            max="100"
                            step="0.01"
                            required
                            value={row.Weightage_Percent}
                            onChange={(e) =>
                              updateComponent(
                                index,
                                "Weightage_Percent",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col-md-2">
                          <label>Weightage Mode</label>
                          <select
                            className="form-select"
                            value={row.Weightage_Mode}
                            onChange={(e) =>
                              updateComponent(
                                index,
                                "Weightage_Mode",
                                e.target.value
                              )
                            }
                          >
                            <option value="PercentOfExam">PercentOfExam</option>
                            <option value="SimpleSum">SimpleSum</option>
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label>Display Label</label>
                          <input
                            type="text"
                            className="form-control"
                            value={row.Display_Label}
                            onChange={(e) =>
                              updateComponent(
                                index,
                                "Display_Label",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="col-md-1">
                          <div className="form-check mt-4">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`include-total-edit-${index}`}
                              checked={row.Include_In_Total}
                              onChange={(e) =>
                                updateComponent(
                                  index,
                                  "Include_In_Total",
                                  e.target.checked
                                )
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`include-total-edit-${index}`}
                            >
                              Total
                            </label>
                          </div>
                        </div>
                        <div className="col-md-1 text-end">
                          <button
                            type="button"
                            className="button button-white button-sm"
                            onClick={() => removeComponentRow(index)}
                          >
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                <div className="text-end">
                  {loading ? (
                    <Spinner animation="border" role="status" />
                  ) : (
                    <button type="submit" className="button button-primary">
                      Update Result Card
                    </button>
                  )}
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditResultCard;
